import MatchDaySection from "./matchDaySection";
import MatchRules from "./matchRules";
import "./matchesContent.sass";

export default function MatchesContent({ groupId, days, onChangeScore }) {
  return (
    <div className="MatchesContent">
      <div className="MatchesBody">
        {days.map((day) => (
          <MatchDaySection
            key={day.dateText}
            groupId={groupId}
            day={day}
            onChangeScore={onChangeScore}
          />
        ))}
      </div>

      <MatchRules />
    </div>
  );
}